import 'lib/Init';
import { __ } from 'lib/Utilities';
import Swal from 'lib/SwalExtension';
import { SweetAlertNoStyle as SwalLoading } from 'lib/SwalExtension';
import { axios } from 'lib/Init';
import { findIndex as _findIndex } from 'lodash';

export default {
    el: '#app',
    data() {
        const data = {
            billingDetails: {},
            cardInformation: {},
            invoice: {
                taxPercentage: 0,
                referralName: '',
                promotionCode: '',
                discountPercentage: 0,
                promotionCodeID: null,
                invoiceAmount: 0,
            },
            lastComponentIndex: 0,
            currentComponentIndex: 0,
            taxDetails: [],
        }
        return data;
    },
    methods: {
        setLastComponentIndex() {
            this.lastComponentIndex = this.currentComponentIndex;
        },
        billingDetailsDidSubmit(billingDetails) {
            this.billingDetails = billingDetails;
            this.nextComponent();
        },
        provinceDidChange(provinceSelected) {
            const allProvinces = window.s.provinces;
            axios.post(window.s.API.postTaxDetails, {
                'province': provinceSelected,
            }).then(response => {
                if (response.data.success) {
                    this.taxDetails = response.data.taxDetails;
                    allProvinces.forEach(province => {
                        if (province.code === provinceSelected) {
                            this.invoice.taxPercentage = parseFloat(province.tax_rate) * 100;
                            return;
                        }
                    });
                }
            }, (error) => {
                console.log(error);
            });
        },
        cardInformationDidSubmit(cardInformation) {
            this.setLastComponentIndex();
            this.cardInformation = cardInformation;
            Swal.fire({
                title: this.__('purchase.confirm_purchase_title'),
                text: this.__('purchase.confirm_purchase_text'),
                icon: 'info',
                showCancelButton: true,
                confirmButtonText: this.__('purchase.confirm_button_text'),
                cancelButtonText: this.__('purchase.cancel_button_text'),
            }).then((result) => {

                if (result.value) {
                    SwalLoading.fire({
                        title: this.__('purchase.processing_payment_title'),
                        text: this.__('purchase.processing_payment_text'),
                        icon: 'info',
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                    });
                    SwalLoading.showLoading();
                    this.processPayment();
                    return false;
                }
            })
        },
    },
};
